import { ChatActivity } from "../Model/ChatActivity";
import { Checkpoint } from "../Model/Checkpoint";
import { GalleryActivity } from "../Model/GalleryActivity";
import { Game } from "../Model/Game";
import { Image360Activity } from "../Model/Image360Activity";
import { InfoActivity } from "../Model/InfoActivity";
import { Inventory } from "../Model/Inventory";
import { SecretActivity } from "../Model/SecretActivity";
import { State } from "../Model/State";
const activitiesFactoriesMap = {
    chat: createChatActivity,
    info: createInfoActivity,
    secret: createSecrectActivity,
    gallery: createGalleryActivity,
    image360: createImage360Activity,
};
export function gameFactory(gameDto) {
    const checkpoints = gameDto.checkpoints.map(checkpointDto => {
        var _a;
        const activities = {};
        for (const [type, factory] of Object.entries(activitiesFactoriesMap)) {
            if (checkpointDto.activities[type]) {
                activities[type] = factory(addDefaultPointsIfRequired(checkpointDto.activities[type]));
            }
        }
        return new Checkpoint(checkpointDto.id, checkpointDto.name, checkpointDto.description, checkpointDto.clue || null, (_a = checkpointDto === null || checkpointDto === void 0 ? void 0 : checkpointDto.lookAtPlayer) !== null && _a !== void 0 ? _a : false, checkpointDto.accesibility, activities, new Inventory(checkpointDto.inventory || []), new State(checkpointDto.isCompleted), checkpointDto.onCompleted || {}, checkpointDto.position, checkpointDto.marker);
    });
    return new Game(gameDto.startVideo || null, gameDto.endVideo || null, checkpoints);
}
function addDefaultPointsIfRequired(dto) {
    if ('points' in dto) {
        return dto;
    }
    return Object.assign(Object.assign({}, dto), { points: {
            win: 50,
            fail: 5
        } });
}
function createChatActivity(dto) {
    return new ChatActivity(new State(dto.isCompleted), dto.title, dto.points, dto.src, dto.events);
}
function createInfoActivity(dto) {
    return new InfoActivity(new State(dto.isCompleted), dto.title, dto.points, dto.audio, dto.content);
}
function createSecrectActivity(dto) {
    return new SecretActivity(new State(dto.isCompleted), dto.title, dto.points, dto.image, dto.statement, dto.patterns);
}
function createGalleryActivity(dto) {
    return new GalleryActivity(new State(dto.isCompleted), dto.title, dto.points, dto.gallery);
}
function createImage360Activity(dto) {
    return new Image360Activity(new State(dto.isCompleted), dto.title, dto.points, dto.image);
}
